import styled from 'styled-components';
import colors from '../../theme/colors';

const RateItemWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  flex: 1 1 0;
`;
const RateItemValue = styled.span`
  display: block;
  font-size: 20px;
  font-weight: 900;
  color: ${colors.blue};
`;
const RateItemTitle = styled.span`
  display: block;
  font-size: 13px;
`;

export { RateItemWrapper, RateItemValue, RateItemTitle };
